import * as React from "react";
import {
  flexRender,
  getCoreRowModel,
  useReactTable,
  getSortedRowModel,
  SortingState,
  getPaginationRowModel,
} from "@tanstack/react-table";
import Card from "../Reusable/Card";
import Button from "../Reusable/Button";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

export default function ImportPreviewDataTable(props: any) {
  const { title, isSubmit, columns, data, handleSubmit, isUploading } = props;
  const [sorting, setSorting] = React.useState<SortingState>([]);

  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
    },
    initialState: {
      pagination: {
        pageSize: 10,
      },
    },
    getCoreRowModel: getCoreRowModel(),
    onSortingChange: setSorting,
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  return (
    <Card title={title}>
      <>
        <div className={tw`flex flex-col mx-auto py-4  `}>
          <div className={tw`overflow-auto`}>
            <table className={tw`border`}>
              <thead>
                {table.getHeaderGroups().map((headerGroup) => (
                  <tr
                    key={headerGroup.id}
                    className={tw`border-b text-gray-800 uppercase whitespace-nowrap w-full`}
                  >
                    {headerGroup.headers.map((header) => (
                      <th
                        key={header.id}
                        className={tw`px-4 pr-2 py-4 font-medium text-left`}
                      >
                        {header.isPlaceholder ? null : (
                          <div
                            {...{
                              className: header.column.getCanSort()
                                ? tw`cursor-pointer select-none flex min-w-[36px]`
                                : tw``,
                              onClick: header.column.getToggleSortingHandler(),
                            }}
                          >
                            {flexRender(
                              header.column.columnDef.header,
                              header.getContext()
                            )}
                            {{
                              asc: <span className={tw`pl-2`}>↑</span>,
                              desc: <span className={tw`pl-2`}>↓</span>,
                            }[header.column.getIsSorted() as string] ?? null}
                          </div>
                        )}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody>
                {table.getRowModel().rows.map((row) => (
                  <tr key={row.id} className={tw`border-b`}>
                    {row.getVisibleCells().map((cell) => (
                      <td
                        key={cell.id}
                        className={tw`px-4 pt-[14px] pb-[18px]`}
                      >
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div
            className={tw`flex sm:flex-row flex-col w-full mt-8 items-center gap-2 text-xs`}
          >
            <div className={tw`sm:mr-auto sm:mb-0 mb-2`}>
              <span className={tw`mr-2`}>Items Per Page</span>
              <select
                className={tw`border p-1 rounded w-16 border-gray-200`}
                value={table.getState().pagination.pageSize}
                onChange={(e) => {
                  table.setPageSize(Number(e.target.value));
                }}
              >
                {[10, 50, 100].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    {pageSize}
                  </option>
                ))}
              </select>
            </div>
            <div className={tw`flex gap-2`}>
              <button
                className={tw`${
                  !table.getCanPreviousPage()
                    ? tw`bg-gray-100`
                    : tw`hover:bg-gray-200 hover:curstor-pointer bg-gray-100`
                } rounded p-1`}
                onClick={() => table.setPageIndex(0)}
                disabled={!table.getCanPreviousPage()}
              >
                <span className={tw`w-5 h-5`}>{"<<"}</span>
              </button>
              <button
                className={tw`${
                  !table.getCanPreviousPage()
                    ? tw`bg-gray-100`
                    : tw`hover:bg-gray-200 hover:curstor-pointer bg-gray-100`
                } rounded p-1`}
                onClick={() => table.previousPage()}
                disabled={!table.getCanPreviousPage()}
              >
                <span className={tw`w-5 h-5`}>{"<"}</span>
              </button>
              <span className={tw`flex items-center gap-1`}>
                <input
                  min={1}
                  max={table.getPageCount()}
                  type="number"
                  value={table.getState().pagination.pageIndex + 1}
                  onChange={(e) => {
                    const page = e.target.value
                      ? Number(e.target.value) - 1
                      : 0;
                    table.setPageIndex(page);
                  }}
                  className={tw`border p-1 rounded w-10`}
                />
                Page {table.getPageCount()}
              </span>
              <button
                className={tw`${
                  !table.getCanNextPage()
                    ? tw`bg-gray-100`
                    : tw`hover:bg-gray-200 hover:curstor-pointer bg-gray-100`
                } rounded p-1`}
                onClick={() => table.nextPage()}
                disabled={!table.getCanNextPage()}
              >
                <span className={tw`w-5 h-5`}>{">"}</span>
              </button>
              <button
                className={tw`${
                  !table.getCanNextPage()
                    ? tw`bg-gray-100`
                    : tw`hover:bg-gray-200 hover:curstor-pointer bg-gray-100`
                } rounded p-1`}
                onClick={() => table.setPageIndex(table.getPageCount() - 1)}
                disabled={!table.getCanNextPage()}
              >
                <span className={tw`w-5 h-5`}>{">>"}</span>
              </button>
            </div>
          </div>
        </div>
        {isSubmit ? (
          <div className={tw`flex justify-end w-full`}>
            <div className={tw`w-[100px] mr-4`}>
              <Button
                label={"Upload"}
                isLoading={isUploading}
                disabled={isUploading}
                onClick={handleSubmit}
              />
            </div>
          </div>
        ) : (
          ""
        )}
      </>
    </Card>
  );
}
